module.exports = __webpack_public_path__ + "static/media/guest.de5ee280.png";